import moment from 'moment-timezone';

const monthOptions = Array(6).fill('').map((_, index) => {
  return moment().add(-index, 'months').format('YYYY-MM');
});

const schema = {
  'type': 'object',
  'required': [
    'organizationId', 'month', 'category', 'name',
  ],
  'properties': {
    'organizationId': {
      'type': 'string',
      'title': '組織名稱',
    },
    'month': {
      'type': 'string',
      'title': '月份',
      'enum': monthOptions,
      'enumNames': monthOptions,
      'default': monthOptions[0],
    },
    'category': {
      'type': 'string',
      'title': '類別',
      'enum': ['縣市核銷報表'],
      'enumNames': ['縣市核銷報表'],
      'default': '縣市核銷報表',
    },
    'name': {
      'type': 'string',
      'title': '名稱',
    },
    'note': {
      'type': ['string', 'null'],
      'title': '備註',
    },
  },
};

export default schema;
